// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Translate__translate-c6e585 {
  background-color: var(--base-30);
  padding: 7px 12px;
  font: var(--font-subtitle-3);
  letter-spacing: var(--font-spacing-subtitle-3);
  display: flex;
  align-items: center;
  margin: 10px -12px -10px -12px;
  clear: both;
  float: left;
  width: 100%;
  color: var(--chat-bubble-text-secondary);
}

.Translate__icon-c35028 {
  fill: currentColor;
  margin-inline-end: 8px;
}

.Translate__label-ef8de4 {
  margin-inline-end: 16px;
}

.Translate__toggle-d40ce2 {
  cursor: pointer;
  color: var(--chat-bubble-text-primary);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/bubbles/components/Translate/styles.m.scss"],"names":[],"mappings":"AAAA;EACE,gCAAA;EACA,iBAAA;EACA,4BAAA;EACA,8CAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,wCAAA;AACF;;AAEA;EACE,kBAAA;EACA,sBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,eAAA;EACA,sCAAA;AACF","sourcesContent":[".translate {\n  background-color: var(--base-30);\n  padding: 7px 12px;\n  font: var(--font-subtitle-3);\n  letter-spacing: var(--font-spacing-subtitle-3);\n  display: flex;\n  align-items: center;\n  margin: 10px -12px -10px -12px;\n  clear: both;\n  float: left;\n  width: 100%;\n  color: var(--chat-bubble-text-secondary);\n}\n\n.icon {\n  fill: currentColor;\n  margin-inline-end: 8px;\n}\n\n.label {\n  margin-inline-end: 16px;\n}\n\n.toggle {\n  cursor: pointer;\n  color: var(--chat-bubble-text-primary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"translate": `Translate__translate-c6e585`,
	"icon": `Translate__icon-c35028`,
	"label": `Translate__label-ef8de4`,
	"toggle": `Translate__toggle-d40ce2`
};
module.exports = ___CSS_LOADER_EXPORT___;
